import React from 'react';
import Calendar from 'react-calendar';
import { ChevronRight } from '@/components/Icons/ChevronRight';
import { formatMonthYear, isSameDay } from '@/utils/date';

interface Props {
  filledDate: Date | null;
  outlinedDate?: Date;
  minDate?: Date;
  maxDate?: Date;
  hasFixedWeekCount?: boolean;
  onChange: (date: Date) => void;
}

export const AbsenceCalendar: React.FC<Props> = ({
  filledDate,
  outlinedDate,
  minDate,
  maxDate,
  hasFixedWeekCount = false,
  onChange,
}) => {
  const handleChange = (next: unknown) => {
    if (next instanceof Date) {
      onChange(next);
    }
  };

  const tileClassName = ({ date }: { date: Date }) => {
    if (filledDate && isSameDay(date, filledDate)) {
      return 'absence-calendar__tile--filled';
    }

    if (outlinedDate && isSameDay(date, outlinedDate)) {
      return 'absence-calendar__tile--outlined';
    }

    return null;
  };

  const defaultActiveStartDate = filledDate ?? outlinedDate ?? undefined;

  return (
    <Calendar
      value={null}
      defaultActiveStartDate={defaultActiveStartDate}
      minDate={minDate}
      maxDate={maxDate}
      showFixedNumberOfWeeks={hasFixedWeekCount}
      onChange={handleChange}
      locale="lv-LV"
      prev2Label={null}
      next2Label={null}
      prevLabel={<ChevronRight className="size-4 rotate-180" />}
      nextLabel={<ChevronRight className="size-4" />}
      minDetail="month"
      formatMonthYear={(_locale, date) => formatMonthYear(date)}
      tileClassName={tileClassName}
      className="absence-calendar"
    />
  );
};
